import { DEFAULT_MEETING_NO_LENGTH, DEFAULT_PORTAL_API_BASE_URL, DEFAULT_PORTAL_APP_NAME } from './constants';
/**
 * 读取 config.js 中的门户相关配置（禁止业务代码写死环境值）。
 */
export function getPortalApiBaseUrl() {
    const fromConfig = typeof config !== 'undefined'
        ? config.portalApiBaseUrl
        : undefined;
    // 空字符串表示同域相对路径 /api/...，不可使用 || 否则会被当成 falsy 回退到 127.0.0.1
    if (fromConfig !== undefined && fromConfig !== null) {
        return String(fromConfig).replace(/\/+$/, '');
    }
    return DEFAULT_PORTAL_API_BASE_URL.replace(/\/+$/, '');
}
/**
 * 门户显示名称。
 */
export function getPortalAppName() {
    const fromConfig = typeof config !== 'undefined'
        ? config.portalAppName
        : undefined;
    return String(fromConfig || DEFAULT_PORTAL_APP_NAME);
}
/**
 * 快速会议默认会议号位数。
 */
export function getDefaultMeetingNoLength() {
    const fromConfig = typeof config !== 'undefined'
        ? config.portalMeetingNoLength
        : undefined;
    const n = Number(fromConfig);
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_MEETING_NO_LENGTH;
}
/**
 * 协议 / 隐私链接。
 */
export function getPortalLegalUrls() {
    const c = typeof config !== 'undefined' ? config : {};
    return {
        termsUrl: String(c.portalTermsUrl || 'https://jitsi.org/meet/tos'),
        privacyUrl: String(c.portalPrivacyUrl || 'https://jitsi.org/meet/privacy')
    };
}
